const inputsValidations = {
  emailRequired: 'Email is required',
  nameRequired: 'Name is required',
  locationNameRequired: 'English location name is required',
  locationNameArRequired: 'Arabic location name is required',
  enNameRequired: 'English name is required',
  arNameRequired: 'Arabic name is required',
  arabicLettersRequired: 'Arabic letters are required',
  pickOneCategoryAtLeast: 'At least one category must be selected',
  pickOneWorkingDayAtLeast: 'At least one working day must be selected',
  pickOneCoverageZoneAtLeast: 'At least one coverage zone must be selected',
  genderRequired: 'Gender is requierd',
  paymentMenthodRequired: 'Payment method is requierd',
  specialtyRequired: 'Specialty is required',
  roleRequired: 'Role is requierd',
  logoRequired: 'Logo is requierd',
  bannerRequired: 'Banner is requierd',
  categoryRequired: 'Category is requierd',
  passwordRequired: 'Password is required',
  tempPasswordRequired: 'Temporary password is required',
  oldPasswordRequired: 'Current password is required',
  streetNumberRequired: 'Street number is required',
  streetNameRequired: 'Street name is required',
  buildingNumberRequired: 'Building number is required',
  postalCodeNumberOnly: 'Postal code should be 5 numbers only',
  newPasswordRequired: 'New password is required',
  validEmailFormat: 'Please enter a valid email format',
  uniqeEmailRequired: 'This email is used before, email should be uniqe',
  confirmNewPasswordRequired: 'Confirm new password is required',
  passwordIsNotMatched: 'Passwords must match',
  passwordNotFollowREGEX:
    'Password should contain at least 8 characters; mix of letters (upper and lower case), numbers, and symbols',
  nameNotFollowREGEX: 'Name should not contain any special characters',
  englishLettersOnly: 'This field only accepts English input',
  arabicLettersOnly: 'This field only accepts Arabic input',
  englishLettersAndSpecialCharactersOnly: 'This field only accepts English letters and special characters',
  arabicLettersAndSpecialCharactersOnly: 'This field only accepts Arabic letters and special characters',
  atleastTwoEnglishCharacters: 'This field should contain at least 2 English characters',
  atleastTwoArabicCharacters: 'This field should contain at least 2 Arabic characters',
  englishSpaceDashSingleQuote: 'This field only accepts English letters, spaces, dash, and single quote',
  arabicDiacriticsSpaceDashSingleQuote: 'This field only accepts Arabic letters, diacritics, spaces, dash, and single quote',
  englishSpaceDashSingleQuoteAndNumbers: 'This field only accepts English letters, spaces, dash, single quote, and numbers',
  arabicDiacriticsSpaceDashSingleQuoteAndNumbers: 'This field only accepts Arabic letters, diacritics, spaces, dash, single quote, and numbers',
  numbersOnly: 'This field only accepts numbers input',
  positiveTwoDecimalOnly: 'This field only accepts positive 2 decimal places numbers input',
  zeroOrPositiveTwoDecimalOnly: 'This field accepts zero or positive numbers, up to 2 decimal places.',
  positiveNegativeTwoDecimalOnly: 'This field only accepts 2 decimal places numbers input',
  positiveNumber: 'This field only accepts positive numbers input',
  invalidDate: 'Date is not valid',
  shouldNotBeBeforeToday: 'Date cannot be before today',
  uploadTypeError: 'Accepted formats are jpg, jpeg, png, and bmp only',
  uploadSizeError: 'Max size is 2MB',
  regionRequired: 'District is required',
  cityRequired: 'City is required',
  countryRequired: 'Country is required',
  required: 'This field is required',
  zeroAndPositiveNumber: 'Thia field only accepts integer number starting from 0',
  numbersStartingFrom2: 'This field accepts numbers starts from 2 only',
  positiveInteger: 'This field accepts positive integer number only',
  startingFromZero: 'This field accepts numbers starts from 0 only',
  integerNumber: 'This field accepts integer number only',
  maximumChars100: "Maximum characters is 100",
  maximumChars50: "Maximum characters is 50",
  atLeastWorkinghour: "Working day is requried with at least a working hour ",
  ToTimeShouldBeAfterFromTime: "To time should be after from Time",
  fromTimeShouldBeBeforeToTime: "From time should be before to time",
  allowLocationAccessMsg:"Please allow location access from your browser settings in order to select the supported region",
  acceptedFilesImgPdf:"Accepted formats: pdf, jpg, jpeg, png",
  acceptedSize:"Max size: 5MB",
  // onlyEnglishSpaceDotCommaSemicolon:"The field accepts only English letters and [ , / ; / . ]",
  // onlyArabicSpaceDotCommaSemicolon:"The field accepts only Arabic letters and [ , / ; / . ]",
  onlyEnglishSpaceDotCommaSemicolon:"The field accepts only English and special characters",
  onlyArabicSpaceDotCommaSemicolon:"The field accepts only Arabic and special characters",
  englishAndSpecialCharacters:"The field accepts only English Letters and special characters",
  arabicAndSpecialCharacters:"The field accepts only Arabic Letters and special characters",
  atleastTwoEnglishCharacters:"This field should contain at least 2 English characters",
  atleastTwoArabicCharacters:"This field should contain at least 2 Arabic characters",
  minimumTwoSessionsRequired: "Minimum 2 sessions required",
};

export default inputsValidations;
